/** Compact display for view counts (e.g. 1.2K, 3.4M). */
export function formatViewCount(count: number): string {
  if (!Number.isFinite(count) || count < 0) return '0';
  const n = Math.floor(count);
  if (n >= 1_000_000) {
    const v = n / 1_000_000;
    return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (n >= 1_000) {
    const v = n / 1_000;
    return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace(/\.0$/, '')}K`;
  }
  return String(n);
}
